import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { desktop, noDesktop } from '../../style/constants';
import MediaQuery from '../common/MediaQuery';
import isClientside from '../../utils/isClientside';
import CentralizeButton from '../../VuexyDesign/atoms/CentralizeButton';

const LoginMenu = () => {
  const { t } = useTranslation('header');
  let hasLoggedInBefore = false;
  if (isClientside) {
    hasLoggedInBefore = Boolean(localStorage.getItem('hasLoggedInBefore'));
  }

  return (
    <Container>
      <MediaQuery query={desktop}>
        {hasLoggedInBefore ? (
          <>
            <Link href="/login" prefetch={false}>
              <CentralizeButton
                size="sm"
                color="primary"
                text={t('header:signIn') as string}
                className="mb-sm-0"
              />
            </Link>
          </>
        ) : (
          <>
            <Link href="/register" prefetch={false}>
              <CentralizeButton
                size="sm"
                color="primary"
                text={t('header:createAccount') as string}
                className="mb-sm-0"
              />
            </Link>
          </>
        )}
      </MediaQuery>
      <MediaQuery query={noDesktop}>
        <Link href="/login">
          <CentralizeButton
            size="md"
            text={t('header:signIn') as string}
            color="primary"
            className="ml-1"
          />
        </Link>
      </MediaQuery>
    </Container>
  );
};

export default LoginMenu;

const Container = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-left: 15px;
  }
`;
